import { render, staticRenderFns } from "./ProductShow.vue?vue&type=template&id=dcbc6c08&scoped=true&"
import script from "./ProductShow.vue?vue&type=script&lang=js&"
export * from "./ProductShow.vue?vue&type=script&lang=js&"
import style0 from "./ProductShow.vue?vue&type=style&index=0&id=dcbc6c08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcbc6c08",
  null
  
)

export default component.exports